// extracted by mini-css-extract-plugin
export default {"titleWrap":"titleWrap---ZuqVs","title":"title---uj6Mm"};